import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginEventService {
  constructor(protected httpClient: HttpClient) {}

  loginEvent(serviceagreementId: string, userId: string) {
    return this.httpClient.post(
      '/api/bss-event-listener/client-api/v2/loginevent',
      { serviceagreementId, userId }
    );
  }
}
